export const arkiStore = {
    dictionary: {}
};
